import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetRenewalAdjustmentByClientId = async (Id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_RENEWAL_ADJUSTMENT_BY_CLIENT_ID + Id,
    token
  );
  return res;
};

export const UpdateAdjustment = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_ADJUSTMENT, payload, token);
  return res;
};
